"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZENDESK_LINK = exports.URLS = exports.DEV_PORTAL_GUIDES = void 0;
exports.cleanPath = cleanPath;
exports.learnMoreLink = exports.isSelfServiceSiProject = exports.isSelfService = exports.isApiCentral = exports.host = void 0;
var getNodeEnv = function getNodeEnv() {
  var env = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  console.log(env);
  if (env.toLowerCase().includes('dev')) return 'DEV';
  if (env.toLowerCase().includes('dit')) return 'DIT';
  if (env.toLowerCase().includes('iat')) return 'IAT';
  if (env.toLowerCase().includes('prod')) return 'PROD';
};
var APP_ENV = getNodeEnv(process.env.REACT_APP_ENVIRONMENT || window.SERVER_ENV) || 'DEV';
var host = {
  'DEV': 'https://marketplace-apis-dit.oneadp.com',
  'DIT': 'https://marketplace-apis-dit.oneadp.com',
  'IAT': 'https://marketplace-apis-iat.adp.com',
  'PROD': 'https://marketplace-apis.adp.com'
}[APP_ENV];
exports.host = host;
var ZENDESK_LINK = 'https://partnersupport.adp.com/hc/en-us/requests/new';
exports.ZENDESK_LINK = ZENDESK_LINK;
var DEV_PORTAL_GUIDES = 'https://developers.adp.com/build/guides/product-integration-guides';
exports.DEV_PORTAL_GUIDES = DEV_PORTAL_GUIDES;
var learnMoreLink = 'https://developers.adp.com/articles/general/adp-event-apis-and-event-notification-guide?query=event%20notifications';
exports.learnMoreLink = learnMoreLink;
var URLS = {
  'api_central': {
    'get': {
      'operations': '/marketplace/dev-portal-context/v2/operations',
      'operation-details': '/marketplace/dev-portal-context/v2/operation-details',
      'postman-collections': '/marketplace/dev-portal-context/v2/postman-collections',
      'related-guides': '/marketplace/dev-portal-context/v2/related-guides'
    }
  },
  'self_service': {
    'get': {
      'operations': '/marketplace/dev-portal-context/v2/operations',
      'operation-details': '/marketplace/dev-portal-context/v2/operation-details',
      'postman-collections': '/marketplace/dev-portal-context/v2/postman-collections',
      'related-guides': '/marketplace/dev-portal-context/v2/related-guides',
      'project-use-case': '/api/project-use-case-list'
    }
  }
};
exports.URLS = URLS;
function cleanPath() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (url.includes('self-service/')) {
    url = url.replace('self-service/', '');
  }
  // if (url.includes('api-central/')) {
  //     url = url.replace('api-central/', '');
  // }
  return url;
}
var isApiCentral = function isApiCentral() {
  var projectApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return projectApp.toLowerCase() === 'api_central';
};
exports.isApiCentral = isApiCentral;
var isSelfService = function isSelfService() {
  var projectApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return projectApp.toLowerCase() === 'self_service';
};
exports.isSelfService = isSelfService;
var isSelfServiceSiProject = function isSelfServiceSiProject() {
  var projectApp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return projectApp.toLowerCase() === 'self_service_si_project';
};
exports.isSelfServiceSiProject = isSelfServiceSiProject;